import { Role } from "./role.model";

export const RolePermission = {
	EXPORT: "*:export",
	APPLICATIONS_UPLOAD: "applications:upload",
	APPLICATIONS_RENAME: "applications:rename",
	APPLICATIONS_DELETE: "applications:delete",
	AI_UPLOAD: "ai:upload",
	AI_RENAME: "ai:rename",
	AI_DELETE: "ai:delete",
	HARDWARE_ASSETS_UPLOAD: "hardware-assets:upload",
	HARDWARE_ASSETS_RENAME: "hardware-assets:rename",
	HARDWARE_ASSETS_DELETE: "hardware-assets:delete",
	TOOLBOX_FILE_UPLOAD: "toolbox:file:upload",
	TOOLBOX_FILE_RENAME: "toolbox:file:rename",
	TOOLBOX_FILE_DELETE: "toolbox:file:delete",
	USERS_VIEW: "users:view",
	USERS_CREATE: "users:create",
	USERS_UPDATE: "users:update",
	USERS_ASSIGN_ROLE: "users:assign-role"
} as const;

export type RolePermissionKey = (typeof RolePermission)[keyof typeof RolePermission];

export const ROLE_LEVELS: Readonly<Record<Role, number>> = {
	[Role.VIEWER]: 1,
	[Role.USER]: 2,
	[Role.ADMIN]: 3
};

export const ROLE_PERMISSIONS: Readonly<Record<Role, readonly RolePermissionKey[]>> = {
	[Role.VIEWER]: [RolePermission.EXPORT],
	[Role.USER]: [
		RolePermission.EXPORT,
		RolePermission.APPLICATIONS_UPLOAD,
		RolePermission.AI_UPLOAD,
		RolePermission.HARDWARE_ASSETS_UPLOAD,
		RolePermission.TOOLBOX_FILE_UPLOAD
	],
	[Role.ADMIN]: Object.values(RolePermission)
};
